import React from 'react';
import { Link } from 'react-router-dom';
import useTranslation from '../../hooks/useTranslation';
import LanguageSelector from './LanguageSelector';

function HeaderMenu({ closeExpanded }) {
    const { t } = useTranslation();

    // Get menu items from config
    const menuItems = t('menu.items', [
        { path: '/', label: 'Tracker', icon: 'map' },
        { path: '/menu', label: 'Menukaart', icon: 'menu' },
        { path: '/info', label: 'Info', icon: 'info' }
    ]);

    return (
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
            {menuItems.map((item, index) => (
                <Link
                    key={item.path}
                    className={`nav-item nav-link ${index === 0 ? 'bordered' : ''}`}
                    to={item.path}
                    onClick={closeExpanded}
                >
                    {item.label}
                </Link>
            ))}
            <LanguageSelector variant="collapsed" />
        </div>
    );
}

export default HeaderMenu;
